const esLang = {
  title: 'Contacto',
}
const enLang = {
  title: 'Contact',
}

export const langTexts = {
  es: esLang,
  en: enLang
} 